import {
  Box,
  Button,
  ColumnLayout,
  FlashbarProps,
  FormField,
  Header,
  Modal,
  SpaceBetween,
  Table,
  Textarea,
} from '@amzn/awsui-components-react-v3';
import React, { useState } from 'react';
import { StatusIcon } from 'src/components/permissions/myDatasets/statusIcon';
import { getReview, submitReview } from 'src/api/notifications';
import { APPROVE, CUSTODIAN, DENY, NEEDS_MORE_DATA, REVIEW_SUBMISSION_SUCCESS_MESSAGE } from 'src/commons/constants';

export interface CustodianReviewModalProps {
  setContentType: any;
  activeGroup: string;
  username: string;
  activeWorkspace: any;
  visible: boolean;
  dismiss: any;
  action: string;
  resources: any;
  selectedResources: any;
  setNotifications: any;
  refresh: any;
  resourceColumnDefinitions: any;
}

export const ReviewDecisionModal = (props: CustodianReviewModalProps) => {
  const [comments, setComments] = useState<string>(undefined);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleSubmit = async () => {
    let submitReviewSuccess = false;
    setButtonLoading(true);
    for (let resource of props.selectedResources) {
      let reviewId = resource.reviewId;
      let action = null;
      if (props.action == 'approve') {
        action = APPROVE;
      }
      if (props.action == 'deny') {
        action = DENY;
      }
      if (props.action == 'needsMoreData') {
        action = NEEDS_MORE_DATA;
      }
      if (action == null) {
        console.log('Action not defined');
        return;
      }

      let getReviewResponse = await getReview({ reviewId: reviewId });
      let reviewers = getReviewResponse.review.reviewers;
      const submitReviewRequestList = [];
      submitReviewRequestList.push({
        reviewId: reviewId,
        reviewerPersona: CUSTODIAN,
        updates: {
          decision: action,
          comment: comments,
        },
      });
      for (let review of reviewers) {
        if (review.persona == CUSTODIAN) {
          if (review.reviewer.gladstoneGroupId != null || review.reviewer.gladstoneWorkspaceId) {
            submitReviewRequestList.push({
              reviewId: reviewId,
              reviewerPersona: CUSTODIAN,
              reviewer: review.reviewer,
              updates: {
                decision: action,
                comment: comments,
              },
            });
          }
        }
      }
      for (let submitReviewRequest of submitReviewRequestList) {
        try {
          let res = await submitReview(submitReviewRequest);
          if (res?.result == REVIEW_SUBMISSION_SUCCESS_MESSAGE) {
            submitReviewSuccess = true;
            break;
          }
        } catch (e) {
          continue;
        }
      }
    }
    setButtonLoading(false);
    if (submitReviewSuccess) {
      props.setNotifications([
        {
          type: 'success' as FlashbarProps.Type,
          content: `Successfully submitted review.`,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
    } else {
      props.setNotifications([
        {
          type: 'error' as FlashbarProps.Type,
          content: `Failed to submit review.`,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
    }
    props.dismiss();
    props.refresh();
  };

  return (
    <Modal
      onDismiss={props.dismiss}
      visible={props.visible}
      closeAriaLabel='Close modal'
      footer={
        <Box float='right'>
          <SpaceBetween direction='horizontal' size='xs'>
            <Button variant='link' onClick={props.dismiss}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleSubmit} loading={buttonLoading}>
              Submit
            </Button>
          </SpaceBetween>
        </Box>
      }
      size='medium'
      header='Batch submit reviews'
    >
      <ColumnLayout>
        <Table
          columnDefinitions={props.resourceColumnDefinitions}
          items={props.resources}
          loadingText='Loading resources'
          sortingDisabled
          header={<Header> Resources </Header>}
        />

        <FormField label='Review decision'>
          <StatusIcon status={props.action} />
        </FormField>

        <FormField label='Comments'>
          <Textarea
            placeholder={'Comments'}
            value={comments}
            onChange={(e) => {
              setComments(e.detail.value);
            }}
          />
        </FormField>
      </ColumnLayout>
    </Modal>
  );
};
